/** 用户协议 */
<template>
  <div class="home protocol-home">
    <Layout
      type="HOME"
      pageTitle="需求方管理"
      titleSrc="/menu/homeIcon_black.png"
    >
      <BasiceLayout
        title="标准节点CMDB变更"
        class="bonus-code-layout"
      >
        <main class="download-wrap">
          <div class="crm-node-content">
            <!-- <h1 class="download-title">Dcache节点添加</h1> -->
            <div>
              <el-input
                class="search-mac-input margin-20"
                v-model="serverID"
                placeholder=""
                @change="search"
              ></el-input>
              <el-button
                class="margin-20"
                type="primary"
                @change="search"
              >获取信息</el-button>
              <el-button
                class="margin-20"
                type="primary"
                @click="offlineServer"
              >操作下线</el-button>
              <el-button
                class="margin-20"
                type="primary"
                @click="updateServer"
              >更新</el-button>
            </div>

            <div>
              <el-input
                class="search-mac-input margin-20"
                v-model="serverHostname"
                placeholder="主机名"
              ></el-input>
              <el-input
                class="search-mac-input margin-20"
                v-model="serverService"
                placeholder="服务类型"
              ></el-input>
              <el-input
                class="search-mac-input margin-20"
                v-model="serverServiceID"
                placeholder="服务ID"
              ></el-input>
              <el-input
                class="search-mac-input margin-20"
                v-model="serverExtIP"
                placeholder="服务器公网IP"
              ></el-input>
              <el-input
                class="search-mac-input margin-20"
                v-model="serverBcode"
                placeholder="服务器绑定码"
              ></el-input>
              <el-input
                class="search-mac-input margin-20"
                v-model="country"
                placeholder="国家"
              ></el-input>
              <el-input
                class="search-mac-input margin-20"
                v-model="province"
                placeholder="	省份"
              ></el-input>
              <el-input
                class="search-mac-input margin-20"
                v-model="city"
                placeholder="	城市"
              ></el-input>
              <el-input
                class="search-mac-input margin-20"
                v-model="operator"
                placeholder="运营商"
              ></el-input>
              <el-input
                class="search-mac-input margin-20"
                v-model="serverServiceStatus"
                placeholder="服务状态"
              ></el-input>
              <el-input
                class="search-mac-input margin-20"
                v-model="serverOwner"
                placeholder="服务器提供方"
              ></el-input>
              <el-input
                class="search-mac-input margin-20"
                v-model="serverJumperIP"
                placeholder="服务器登录IP"
              ></el-input>
              <el-input
                class="search-mac-input margin-20"
                v-model="serverJumperPort"
                placeholder="服务器登录端口"
              ></el-input>
              <el-input
                class="search-mac-input margin-20"
                v-model="serverPasswd"
                placeholder="服务器密码"
              ></el-input>
              <el-input
                class="search-mac-input margin-20"
                v-model="serverAccount"
                placeholder="服务器绑定账号"
              ></el-input>
              <el-input
                class="search-mac-input margin-20"
                v-model="serverIntIP"
                placeholder="服务器管理IP"
              ></el-input>
              <el-input
                class="search-mac-input margin-20"
                v-model="serverOnlineDate"
                placeholder="上线时间"
              ></el-input>
              <el-input
                class="search-mac-input margin-20"
                v-model="serverOfflineDate"
                placeholder="下线时间"
              ></el-input>
              <el-input
                class="search-mac-input margin-20"
                v-model="serverRelatedID"
                placeholder="服务器关联ID"
              ></el-input>
              <el-input
                class="search-mac-input margin-20"
                v-model="bandwidthMb"
                placeholder="网络带宽Mbps"
              ></el-input>
              <el-input
                class="search-mac-input margin-20"
                v-model="serverNetType"
                placeholder="服务器网络类型"
              ></el-input>
              <el-input
                class="search-mac-input margin-20"
                v-model="serverNote"
                placeholder="服务器备注"
              ></el-input>
              <el-input
                class="search-mac-input margin-20"
                v-model="serverRecords"
                placeholder="服务器备注信息"
              ></el-input>
              <el-input
                class="search-mac-input margin-20"
                v-model="serverOwnerID"
                placeholder="用户id"
              ></el-input>
              <el-input
                class="search-mac-input margin-20"
                v-model="serverLoginAccount"
                placeholder="服务器登陆账号"
              ></el-input>
              <el-input
                class="search-mac-input margin-20"
                v-model="serverDeployStatus"
                placeholder="服务器状态"
              ></el-input>
              <el-input
                class="search-mac-input margin-20"
                v-model="serverConfigID"
                placeholder="serverConfigID"
              ></el-input>
              <el-input
                class="search-mac-input margin-20"
                v-model="updateBandwidth"
                placeholder="调整带宽"
              ></el-input>
              <el-input
                class="search-mac-input margin-20"
                v-model="serverGateway"
                placeholder="网关地址"
              ></el-input>
              <el-button
                class="margin-20"
                type="primary"
                @click="onlineServer"
              >上线新server</el-button>
            </div>
          </div>
        </main>
      </BasiceLayout>
    </Layout>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { log } from "util";
import { Message } from "element-ui";
import Header from "@/components/Header.vue";
import moment from "moment";
import Layout from "@/components/CRM/Layout.vue";
import BasiceLayout from "@/components/Common/BasicLayout.vue";

export default {
  name: "home",
  data() {
    return {
      serverID: "",
      serverHostname: "",
      serverService: "",
      serverServiceID: "",
      serverExtIP: "",
      serverBcode: "",
      country: "",
      province: "",
      city: "",
      operator: "",
      serverServiceStatus: "",
      serverOwner: "",
      serverJumperIP: "",
      serverJumperPort: "",
      serverPasswd: "",
      serverAccount: "",
      serverIntIP: "",
      serverOnlineDate: "",
      serverOfflineDate: "",
      serverRelatedID: "",
      bandwidthMb: "",
      serverNetType: "",
      serverNote: "",
      serverRecords: "",
      serverOwnerID: "",
      serverLoginAccount: "",
      serverDeployStatus: "",
      serverConfigID: "",
      updateBandwidth: "",
      serverGateway: ""
    };
  },
  computed: mapState({}),
  components: {
    Header,
    Layout,
    BasiceLayout
  },
  methods: {
    ...mapActions([
      "getServerByAdmin",
      "updateCmbdByAdmin",
      "insertCmbdByAdmin"
    ]),
    // 更新server
    updateServer() {
      let { serverID } = this;
      if (!serverID) {
        return Message({
          message: '填写serverID',
          type: "error"
        });
      }
      
      let {
        serverHostname,
        serverService,
        serverServiceID,
        serverExtIP,
        serverBcode,
        country,
        province,
        city,
        operator,
        serverServiceStatus,
        serverOwner,
        serverJumperIP,
        serverJumperPort,
        serverPasswd,
        serverAccount,
        serverIntIP,
        serverOnlineDate,
        serverOfflineDate,
        serverRelatedID,
        bandwidthMb,
        serverNetType,
        serverNote,
        serverRecords,
        serverOwnerID,
        serverLoginAccount,
        serverDeployStatus,
        serverConfigID,
        updateBandwidth,
        serverGateway,
      } = this;

      this.updateCmbdByAdmin({
        type: "update",
        ci_type: "server",
        serverID,
        serverHostname,
        serverService,
        serverServiceID,
        serverExtIP,
        serverBcode,
        country,
        province,
        city,
        operator,
        serverServiceStatus,
        serverOwner,
        serverJumperIP,
        serverJumperPort,
        serverPasswd,
        serverAccount,
        serverIntIP,
        serverOnlineDate,
        serverOfflineDate,
        bandwidthMb,
        serverNote,
        serverRecords,
        serverOwnerID,
        serverLoginAccount,
        serverConfigID,
        updateBandwidth,
        serverGateway,
      }).then(res => {
        Message({
          message: JSON.stringify(res),
          type: "success"
        });
      });
    },
    search() {
      let { serverID } = this;
      this.getServerByAdmin({ serverID }).then(res => {
        if (res && res.data && res.data[0]) {
          let data = res.data[0];
          this.serverID = data.serverID;
          this.serverHostname = data.serverHostname;
          this.serverService = data.serverService;
          this.serverServiceID = data.serverServiceID;
          this.serverExtIP = data.serverExtIP;
          this.serverBcode = data.serverBcode;
          this.country = data.country;
          this.province = data.province;
          this.city = data.city;
          this.operator = data.operator;
          this.serverServiceStatus = data.serverServiceStatus;
          this.serverOwner = data.serverOwner;
          this.serverJumperIP = data.serverJumperIP;
          this.serverJumperPort = data.serverJumperPort;
          this.serverPasswd = data.serverPasswd;
          this.serverAccount = data.serverAccount;
          this.serverIntIP = data.serverIntIP;
          this.serverOnlineDate = data.serverOnlineDate;
          this.serverOfflineDate = data.serverOfflineDate;
          this.serverRelatedID = data.serverRelatedID;
          this.bandwidthMb = data.bandwidthMb;
          this.serverNetType = data.serverNetType;
          this.serverNote = data.serverNote;
          this.serverRecords = data.serverRecords;
          this.serverOwnerID = data.serverOwnerID;
          this.serverLoginAccount = data.serverLoginAccount;
          this.serverDeployStatus = data.serverDeployStatus;
          this.serverConfigID = data.serverConfigID;
          this.updateBandwidth = data.updateBandwidth;
          this.serverGateway = data.serverGateway;
        } else {
          Message("error");
        }
      });
    },
    onlineServer() {
      let {
        serverHostname,
        serverService,
        serverServiceID,
        serverExtIP,
        serverBcode,
        country,
        province,
        city,
        operator,
        serverServiceStatus,
        serverOwner,
        serverJumperIP,
        serverJumperPort,
        serverPasswd,
        serverAccount,
        serverIntIP,
        serverOnlineDate,
        serverOfflineDate,
        serverRelatedID,
        bandwidthMb,
        serverNetType,
        serverNote,
        serverRecords,
        serverOwnerID,
        serverLoginAccount,
        serverDeployStatus,
        serverConfigID,
        updateBandwidth,
        serverGateway
      } = this;

      this.insertCmbdByAdmin({
        ci_type: "server",
        serverHostname,
        serverService,
        serverServiceID,
        serverExtIP,
        serverBcode,
        country,
        province,
        city,
        operator,
        serverServiceStatus: "运行",
        serverOwner,
        serverJumperIP,
        serverJumperPort,
        serverPasswd,
        serverAccount,
        serverIntIP,
        serverOnlineDate: moment().format("YYYY-MM-DD kk:mm:ss"),
        serverOfflineDate,
        serverRelatedID,
        bandwidthMb,
        serverNetType,
        serverNote,
        serverRecords,
        serverOwnerID,
        serverLoginAccount,
        serverDeployStatus,
        serverConfigID,
        updateBandwidth,
        serverGateway,

      }).then(res => {
        Message({
          message: JSON.stringify(res),
          type: "success"
        });
      });
    },
    offlineServer() {
      let { serverID, serverConfigID } = this;
      this.updateCmbdByAdmin({
        ci_type: "server",
        serverID,
        serverConfigID,
        serverOfflineDate: moment().format("YYYY-MM-DD kk:mm:ss"),
        serverServiceStatus: "下线"
      }).then(res => {
        Message({
          message: JSON.stringify(res),
          type: "success"
        });
      });
    }
  },
  created() {}
};
</script>

<style  lang="stylus"></style>
